import { AppContainer, ContentArea, SidebarWrapper, MainContent } from '../App.styles';
import SidebarMenu from './SideBarNav';
import Menu from './menu';
import AppRoutes from '../AppRoutes';
import PrivateRoute from './PrivateRoute';

const AppLayout = () => {
  return (
    <AppContainer>
      <SidebarWrapper>
        <SidebarMenu />
      </SidebarWrapper>
      <MainContent>
        <Menu />
        <ContentArea>
          <PrivateRoute>
            <AppRoutes />
          </PrivateRoute>
        </ContentArea>
      </MainContent>
    </AppContainer>
  );
};

export default AppLayout;
